import VisualisationsToolboxAbstract from '../VisualisationsToolboxAbstract';

class DataExportationToolbox extends VisualisationsToolboxAbstract {
  static addParams() {}

  static canProcess(nextProps) {
    return (
      nextProps.layer &&
      (nextProps.layer.layer_participation_associations.length > 0 ||
        nextProps.layer.layer_group_participations_associations.length > 0) &&
      nextProps.layer.layer_abstract_type_associations.length > 0
    );
  }

  static getVisualisationComponent() {
    return null;
  }

  static getProcessButtonLabel() {
    return 'Export Data';
  }

  static getBlockParameters() {
    return {
      windowdStep: 1,
      windowdSize: 2,
      extract: true
    };
  }
}

export default DataExportationToolbox;



// WEBPACK FOOTER //
// ./src/scenes/analysis/lib/visualisationTypes/DataExportationToolbox.js